const previewBranchName = process.env.REACT_APP_GIT_REF?.toLowerCase() || '';

const isProductionDeployment =
  process.env.REACT_APP_VERCEL_ENV === 'production';

const isLocalDevelopment =
  process.env.NODE_ENV !== 'production' &&
  process.env.REACT_APP_TECO_LOCAL_MODE === 'true';

const isStagingPreviewDeployment = previewBranchName === 'staging';

const isLineLoginEnabled =
  isLocalDevelopment || isProductionDeployment || isStagingPreviewDeployment;

export default isLineLoginEnabled;
